import PropTypes from 'prop-types';
import Container from '@/components/Container';
import Image from '@/components/Image/RemoteImage';

const defaultProps = {
  customers: [],
};

const propTypes = {
  customers: PropTypes.arrayOf(
    PropTypes.shape({
      logo: PropTypes.string,
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
};

export default function CustomerLogos({
  customers,
}) {
  return (
    <Container className="lg:px-20">
      <div className="flex items-center justify-center">
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
          {customers.map(({ logo, title, url }) => (
            <div key={url}>
              <Image
                src={logo}
                alt={title}
                width={300}
                height={190}
              />
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
}

CustomerLogos.defaultProps = defaultProps;
CustomerLogos.propTypes = propTypes;
